import axios from "axios";

export const axiosInternal = axios;

export const axiosInstance = axiosInternal.create({
  timeout: 30000,
});
